import internal from "stream";
import { api, RouteAPI } from "../service/apiService";

export interface SubscriptionPlan {
    id: string;
    name: string;
    projectSlots: number;
    monthlyPrice: number | string;
    internal: boolean;
}

export interface SubscriptionConsumption {
    activeProjectsCount: number;
    projectSlots: number;
}

export const fetchSubscriptionPlans = async (): Promise<SubscriptionPlan[]> => {
    try {
        const response = await api(`${RouteAPI.SUBSCRIPTION}/plans`, "GET");

        if (response.status !== 200 || !Array.isArray(response.data)) {
            throw new Error("Invalid response format");
        }

        console.log("Subscription Plans response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch subscriptionPlans:", error);
        throw error;
    }
};

export const fetchCheckoutLink = async (
    planId: string
): Promise<string | null> => {
    try {
        const response = await api(
            `${RouteAPI.SUBSCRIPTION}/plans/${planId}/checkout-link`,
            "GET"
        );

        if (response.status !== 201) {
            throw new Error("Invalid response format");
        }

        return response.data?.link ?? null;
    } catch (error) {
        console.error("Failed to fetch checkout link:", error);
        throw error;
    }
};

export const fetchPortalLink = async (): Promise<string | null> => {
    try {
        const response = await api(
            `${RouteAPI.SUBSCRIPTION}/portal-link`,
            "GET"
        );

        if (response.status !== 201) {
            throw new Error("Invalid response format");
        }

        return response.data?.link ?? null;
    } catch (error) {
        console.error("Failed to fetch portal link:", error);
        throw error;
    }
};

export const fetchConsumption = async (): Promise<SubscriptionConsumption> => {
    try {
        const response = await api(
            `${RouteAPI.SUBSCRIPTION}/consumption`,
            "GET"
        );

        if (response.status !== 200 || !response.data) {
            throw new Error("Invalid response format");
        }

        const consumption: SubscriptionConsumption = {
            activeProjectsCount: response.data.activeProjectsCount || 0,
            projectSlots: response.data.projectSlots || 0,
        };

        return consumption;
    } catch (error) {
        console.error("Failed to fetch subscription consumption:", error);
        throw error;
    }
};
